import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./index.css";
import Companyproof from "./pages/Companyproof";
import { useSelector } from "react-redux";
import { RootState } from "./store";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Invalid from "./pages/invalid";
import BankStatement from "./pages/bankStatement";
import UploadEmiratesID from "./pages/UploadEmiratesID";
import Salaryslip from "./pages/Salaryslip";

const router = createBrowserRouter([
  {
    path: "/proof",
    element: <Companyproof />,
  },
  {
    path: "/uploadid",
    element: <UploadEmiratesID />,
  },
  {
    path: "/bankstatement",
    element: <BankStatement />,
  },
  {
    path: "/invalid",
    element: <Invalid />,
  },
  {
    path: "/salaryslip",
    element: <Salaryslip />,
  },
]);

const Router = () => {
  // Hooks
  const loading = useSelector((state: RootState) => state.setting.loading);
  // Effects
  return (
    <>
      <ToastContainer autoClose={5000} />
      <div className="bg-primary">
        <div className="w-full h-[100vh] max-w-md bg-primary mx-auto">
          {loading && (
            <>
              <div className="w-full h-full bg-black bg-opacity-50 flex items-center justify-center absolute top-0 left-0 z-50">
                <img src="/assets/cashe.gif" alt="" className="w-48 h-48" />
              </div>
            </>
          )}
          <RouterProvider router={router} />
        </div>
      </div>
    </>
  );
};
export default Router;
